/* eslint-disable react/prop-types */
import React from 'react';
import styles from './styles.module.scss';

/**
 * Badge component
 * @param {object} props - Component props
 * @param {string} props.src - img tag src attribute
 * @param {string} props.alt - alt text for image
 */
export const Badge = ({ src, alt }) => {
  if (!(src && alt)) {
    return null;
  }
  return (
    <img src={src} className={styles.badge} alt={alt} />
  );
};
